'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherExternalLink, FeatherRefreshCw } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import { formatDataPrazo } from '@/shared/formatters';
import type { CustasProcesso } from '../types/custasProcessoTypes';
import { custasNoPrazoAdicional } from '../utils/custasProcessoUtils';
import { formatarPrazoFinalPagamento } from '../utils/financeiroProcessoClienteUtils';
interface CustasPendentesBannerProps {
  custas: CustasProcesso;
  regerando?: boolean;
  pagamentoSuspenso?: boolean;
  onPagar: () => void;
  onRegerarCobranca: () => void;
}
const ESTADOS_VISIVEIS: readonly CustasProcesso['estado'][] = ['EMITIDA', 'EM_PRORROGACAO', 'VENCIDA'];
export function CustasPendentesBanner(t0) {
  const $ = _c(39);
  const {
    custas,
    regerando: t1,
    pagamentoSuspenso: t2,
    onPagar,
    onRegerarCobranca
  } = t0;
  const regerando = t1 === undefined ? false : t1;
  const pagamentoSuspenso = t2 === undefined ? false : t2;
  if (!ESTADOS_VISIVEIS.includes(custas.estado)) {
    return null;
  }
  const isSemPagamentoPossivel = custas.estado === "VENCIDA";
  let t3;
  if ($[0] !== custas || $[1] !== isSemPagamentoPossivel) {
    t3 = custasNoPrazoAdicional(custas) || isSemPagamentoPossivel;
    $[0] = custas;
    $[1] = isSemPagamentoPossivel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isVencida = t3;
  let t4;
  if ($[3] !== custas.prazoFinalPagamentoEm) {
    t4 = formatarPrazoFinalPagamento(custas.prazoFinalPagamentoEm);
    $[3] = custas.prazoFinalPagamentoEm;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const prazoFinal = t4;
  let t5;
  if ($[5] !== custas.acoes) {
    t5 = custas.acoes.includes("REGERAR");
    $[5] = custas.acoes;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const podeRegerar = t5;
  let t6;
  if ($[7] !== custas.acoes) {
    t6 = custas.acoes.includes("PAGAR");
    $[7] = custas.acoes;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const podePagar = t6;
  const t7 = `flex w-full flex-wrap items-center gap-3 rounded-[16px] border border-solid px-4 py-3 ${isVencida ? "border-error-200 bg-error-50" : "border-warning-200 bg-warning-50"}`;
  const t8 = `h-5 w-5 flex-none ${isVencida ? "text-error-600" : "text-warning-600"}`;
  let t9;
  if ($[9] !== t8) {
    t9 = <FeatherAlertTriangle className={t8} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `text-body-bold font-body-bold ${isVencida ? "text-error-900" : "text-warning-900"}`;
  const t11 = isSemPagamentoPossivel ? "Custas vencidas sem pagamento" : isVencida ? "Custas vencidas \u2014 prazo adicional para pagamento" : "Pagamento das custas pendente";
  let t12;
  if ($[11] !== t10 || $[12] !== t11) {
    t12 = <span className={t10}>{t11}</span>;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = `text-caption font-caption ${isVencida ? "text-error-700" : "text-warning-700"}`;
  let t14;
  if ($[14] !== custas.vencimentoEm || $[15] !== isSemPagamentoPossivel || $[16] !== isVencida || $[17] !== prazoFinal) {
    t14 = isSemPagamentoPossivel ? "O prazo para pagamento terminou, e esta cobran\xE7a n\xE3o pode mais ser paga. Fale com a secretaria para saber os pr\xF3ximos passos." : isVencida ? `Ainda dá para pagar pelo mesmo link${prazoFinal ? ` até ${prazoFinal}` : ""}. Sem o pagamento até lá, o processo será encerrado por falta de pagamento.` : `O processo entra em citação assim que o pagamento for confirmado${custas.vencimentoEm ? ` · vence em ${formatDataPrazo(custas.vencimentoEm)}` : ""}.`;
    $[14] = custas.vencimentoEm;
    $[15] = isSemPagamentoPossivel;
    $[16] = isVencida;
    $[17] = prazoFinal;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t13 || $[20] !== t14) {
    t15 = <span className={t13}>{t14}</span>;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t12 || $[23] !== t15) {
    t16 = <div className="flex min-w-[220px] flex-1 flex-col">{t12}{t15}</div>;
    $[22] = t12;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== onRegerarCobranca || $[26] !== podeRegerar || $[27] !== regerando) {
    t17 = podeRegerar && <Button variant="brand-primary" size="medium" icon={<FeatherRefreshCw />} onClick={onRegerarCobranca} disabled={regerando} loading={regerando}>{regerando ? "Gerando\u2026" : "Gerar nova cobran\xE7a"}</Button>;
    $[25] = onRegerarCobranca;
    $[26] = podeRegerar;
    $[27] = regerando;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== onPagar || $[30] !== pagamentoSuspenso || $[31] !== podePagar) {
    t18 = podePagar && <Button variant="brand-primary" size="medium" iconRight={<FeatherExternalLink />} onClick={onPagar} disabled={pagamentoSuspenso}>Pagar custas</Button>;
    $[29] = onPagar;
    $[30] = pagamentoSuspenso;
    $[31] = podePagar;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t7 || $[37] !== t9) {
    t19 = <div className={t7}>{t9}{t16}{t17}{t18}</div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t7;
    $[37] = t9;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
}